import { Formik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import {
  attPreSinAnt,
  attPregestacionalOpt,
  noAplicaOpt,
  noSiOpt,
  opt123,
  primeraVezSubsecuentaOpt,
  inicialSubsecuentaOpt,
  sintomaDepresivaOpt,
  referidoPorOpt,
} from "./constants/options";
import Controller from "./controller/Controller";
import { Fragment, useContext, useState, useEffect } from "react";
import * as Yup from "yup";
import Post from "../../../api/Post";
import { MEDICAL_HISTORY_MX } from "../../../api/Routes";
import { authContext } from "../../../context/AuthContext";
import Put from "../../../api/Put";
import SimpleLoad from "../../../loader/SimpleLoad";
import Get from "../../../api/Get";
const fields1 = [
  {
    name: "lineaVida",
    type: "select",
    label: "Consulta por Linea Vida",
    options: [...noSiOpt],
  },
  {
    name: "cartillaSalud",
    type: "select",
    label: "Consulta por Cartilla de Salud",
    options: [...noSiOpt],
  },
  {
    name: "referidoPor",
    type: "select",
    label: "Referido por",
    options: [...referidoPorOpt],
  },
];

const fields2 = [
  {
    name: "contrarreferido",
    type: "select",
    label: "Contrarreferido por",
    options: [...noAplicaOpt, ...noSiOpt],
  },
  {
    name: "telemedicina",
    type: "select",
    label: "Telemedicina",
    options: [...noSiOpt],
  },
];

export default function HealthPromotion({
  setShowModalServer,
  setErrorServer,
  setShowSuccess,
  citaId,
  promocionSalud,
  validationData,
}) {
  const { auth } = useContext(authContext);
  const [isSubmiting, setSubmiting] = useState(false);
  const [id, setId] = useState(null);
  const schema = Yup.object().shape({
    lineaVida: Yup.number()
      .test(
        'lineaVida',
        'Valor inválido',
        function (value) {
          return value === 0 || value === 1;
        }
      ),
    cartillaSalud: Yup.number()
      .test(
        'cartillaSalud',
        'Valor inválido',
        function (value) {
          return value === 0 || value === 1;
        }
      ),
    referidoPor: Yup.number().test(
      'referidoPor',
      'Valor inválido',
      function (value) {
        const { gender, relacionTemporalEmbarazo, age } = validationData;
        //if (contrarreferido === 0) {
          if (value === 1 || value === 7 || value === 8 || value === 9) {
            return relacionTemporalEmbarazo !== -1;
          } else if (value === 2) {
            return age.years < 18;
          } else {
            return value >= 3 && value <= 6;
          }
        /*} else {
          return value === -1;
        }*/
      }
    ).required('Campo requerido'),
    contrarreferido: Yup.number().test(
      'contrarreferido',
      'Valor inválido',
      function (value) {
        const { referidoPor } = validationData;
        if (referidoPor === -1) {
          return value === 0 || value === 1;
        } else {
          return value === 0;
        }
      }
    ).required('Campo requerido'),

    telemedicina: Yup.number()
      .oneOf([0, 1], 'Valor inválido')
      .required('Campo requerido'),
  });
  const [initValues, setInitValues] = useState(promocionSalud);
  useEffect(() => {
    if (initValues?.id) {
      setSubmiting(true);
      Get({
        url: `${MEDICAL_HISTORY_MX}/find-health-promotion/${initValues.id}`,
        access_token: auth.data.access_token,
      })
        .then((response) => {
          setInitValues(response.data);
          setSubmiting(false);
        })
        .catch((error) => {
          console.log(error);
          setSubmiting(false);
        });
    }
  }, [initValues?.id, auth.data.access_token]);
  return (
    <>
      <Formik
        initialValues={initValues
          ? initValues
          : {
            appointmentId: citaId,
            lineaVida: "0",
            cartillaSalud: "0",
            referidoPor: "-1",
            contrarreferido: "-1",
            telemedicina: "0",
          }}
        validationSchema={schema}
        onSubmit={async (values, { setSubmitting, setFieldValue }) => {
          setSubmiting(true);
          if (id) {
            const body = {
              id,
              ...values,
            };
            try {
              const response = await Put({
                url: `${MEDICAL_HISTORY_MX}/update-health-promotion/`,
                data: body,
                access_token: auth.data.access_token,
                header: true,
              });
              console.log(response);
              setSubmiting(false);
              setTimeout(() => {
                setShowSuccess(false);
              }, 2000);
            } catch (error) { }
          } else {
            try {
              const response = await Post({
                url: `${MEDICAL_HISTORY_MX}/save-health-promotion/`,
                data: values,
                access_token: auth.data.access_token,
                header: true,
              });
              console.log(response);
              setId(response.data.id);
              setSubmiting(false);
              setTimeout(() => {
                setShowSuccess(false);
              }, 2000);
            } catch (error) {
              setSubmiting(false);
              setShowModalServer(true);
              if (error.response) {
                setErrorServer(error.response);
              }
            }
          }
          console.log(values);
        }}
      >
        {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
          <Form onSubmit={handleSubmit}>
            {isSubmiting && <SimpleLoad />}
            <Row>
              <Col xs="12" md="6">
                <dl className="row">
                  {fields1.map((it) => (
                    <Fragment key={it.name}>
                      <dt className="col-sm-5">{it.label}</dt>
                      <dd className="col-sm-7">
                        <Controller
                          type={it.type}
                          name={it.name}
                          errors={errors}
                          onChange={handleChange}
                          options={it.options}
                        />
                      </dd>
                    </Fragment>
                  ))}
                </dl>
              </Col>
              <Col xs="12" md="6">
                <dl className="row">
                  {fields2.map((it) => (
                    <Fragment key={it.name}>
                      <dt className="col-sm-5">{it.label}</dt>
                      <dd className="col-sm-7">
                        <Controller
                          type={it.type}
                          name={it.name}
                          errors={errors}
                          onChange={handleChange}
                          options={it.options}
                        />
                      </dd>
                    </Fragment>
                  ))}
                </dl>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col className="text-right">
                <Button
                  variant="outline-success"
                  className="ok-buttom"
                  type="submit"
                >
                  Guardar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
}
